<script setup lang="ts">
import { RuleExpression, useField } from "vee-validate";
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    id?: string;
    title?: string;
    name?: string;
    rules?: RuleExpression<any>;
    modelValue?: string | number | null;
    readonly?: boolean;
    required?: boolean;
    min?: number | string;
    max?: number | string;
  }>(),
  {
    modelValue: null,
    required: false,
  },
);

const emit = defineEmits(["update:modelValue"]);

// Only hook into vee-validate when a name is actually given
const field = props.name ? useField(() => props.name!, props.rules) : null;

const value = computed({
  get: () => (field ? field.value.value : props.modelValue),
  set: (val) => {
    if (field) {
      field.value.value = val;
    } else {
      emit("update:modelValue", val);
    }
  },
});
</script>

<template>
  <div class="flex flex-col gap-1">
    <label
      :data-allow-mismatch="id"
      class="font-semibold text-gray-800 text-sm"
      >{{ title }}</label
    >
    <textarea
      class="w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#28b473] focus:border-[#28b473]"
      :class="[
        readonly
          ? 'bg-gray-100! border! border-gray-300! text-gray-500! cursor-not-allowed!'
          : '',
      ]"
      v-model="value"
      rows="4"
      type="text"
      v-bind="$attrs"
      :readonly="readonly"
      :min="min"
      :max="max"
    >
    </textarea>
  </div>
</template>
